import { render, staticRenderFns } from "./Formulario.vue?vue&type=template&id=2d6c58a0&scoped=true&"
import script from "./Formulario.vue?vue&type=script&lang=js&"
export * from "./Formulario.vue?vue&type=script&lang=js&"
import style0 from "./Formulario.vue?vue&type=style&index=0&id=2d6c58a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6c58a0",
  null
  
)

export default component.exports